/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from 'react-helmet'
import Consent from './consent'


import Menu from "./menu"
import "../styles/main.scss"


const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
    <Helmet>
      <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap" rel="stylesheet" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
    </Helmet>
    <Menu />
	  {children}
	  <footer className="social"><h2>Get Social With Us</h2>
		<div id="footer-icons"><a href="https://www.facebook.com/profile.php?id=100028020386844" target="_blank" ><img src={"/images/icon-facebook.svg"}  alt="Facebook" /></a><a href="https://www.linkedin.com/company/bgb-group"  target="_blank"><img src={"/images/icon-linkedin.svg"} alt="LinkedIn"  target="_blank" /></a><a href="https://www.instagram.com/bgbgroup/"  target="_blank" ><img src={"/images/icon-insta.svg"} alt="Instagram" /></a><a href="https://www.tiktok.com/@bgbgroup"  target="_blank" ><img src={"/images/icon-ticktok.svg"} alt="Tiktok"  /></a></div>
	</footer>
	<footer className="end-nav">
    <div className="copyright">
        <a href="mailto:info@bgbgroup.com">info@bgbgroup.com</a>
        <br />
        <strong>New York</strong>
      
        Penn1, 250 West 34th Street, 3rd Floor, Suite 302, New York, NY 10119
        <br />
        <br />
        <strong>London</strong>
      
        30 Crown Place, 10th Floor London EC2A 4EB, UK
        <br /><br />
        Copyright © 2024 BGB Group.
        <span className="mobile">
        <br />
        </span>
        All rights reserved.
    </div>

    <div className="links">
      <br />
      <a href="/privacy/">Privacy Policy</a>
      <span className="desktop"> | </span>
      <a href="/terms-of-use/">Terms of Use</a>
      <span className="desktop"> | </span>
      <a href="/press-releases/">Press Releases</a>
      <span className="desktop"> | </span>
      <a href="/connect/">Contact</a>
    </div>
    </footer>
    <Consent />

    </>

  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
